module.exports = __webpack_public_path__ + "img/mikrorurki.eb3b4fad.svg";